module.exports = __webpack_public_path__ + "img/not.2bf34524.png";